import React from 'react';
import { ListTile } from '@thd-olt-component-react/list-tile';

import proptypes from 'prop-types';

const { arrayOf, number, shape, string } = proptypes;

const ListsCompactList = ({ lists, maxMobileListSize, iconSize }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-mb-4">
      {lists?.slice(0, maxMobileListSize).map((list, index) => (
        <ListTile
          iconSize={iconSize}
          key={index + list.id}
          listId={list.id}
          data={list}
          numberOfThumbnails={3}
          enableSharedIcon
          position={index}
          impressionName="ListsActiveState"
          impressionComponent="Lists"
        />
      ))}
    </div>
  );
};

ListsCompactList.propTypes = {
  maxMobileListSize: number,
  lists: arrayOf(shape({
    id: string,
    name: string,
    url: string,
    itemCount: number,
    listAccessType: string,
    images: arrayOf(shape({
      url: string
    }))
  })),
  iconSize: string,
};

ListsCompactList.defaultProps = {
  maxMobileListSize: 4,
  iconSize: 'small',
  lists: [],
};

export default ListsCompactList;
